<template>
<div class="chapter">
<div class="inner_page">
<div class="photo50"><img alt="GBP_TP" class="img100" src="Images/GBP_TP.png"/></div>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books" target="_blank"><img alt="IVP Books Imprint" src="Images/IVPBooks.png"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?22fe688f